import {IOwayoDataModel} from "../model";
import {EntwurfColorData, EntwurfFromDB, Produktresponse} from "../databaseInterfaceClasses";
import {Z_OrderTable} from "../zOrderTable";
import {SelectableObject, TextObject} from "../selectableObjects";
import {EventVerteiler} from '@k/global/eventVerteiler';
import {SELOBEVENTNAMES} from "@k/global/GlobalEventnames";
import globalsObject from "../globalsObject";
import {EntwurfInitialisator} from "../entwurfInitialisator";
import {ResourceInvalidationTriggers} from "@k/global/resourcemanager/resourceManager";
import {IEntwurfStoreWrapper} from "../EntwurfStateWrapper";
import {arrayElementByKeyValue} from "@k/global/arrayHelper";
import {getURLPrefixOfflineVsOnline} from "@k/global/globalUtils";
import {sendPostRequest} from "@k/global/axiosFormWrapper";

export class ReadyDesignLoader {

    private static loggedReadys = new Set<string>();

    private static adaptReadyDesign(model:IOwayoDataModel, entwurfsData:EntwurfFromDB, rdyDesignID:string){
        return new Promise<void>((resolve)=>{
            ReadyDesignLoader.waitForEntwurfInitialisation().then(()=>{
                if (entwurfsData.design===null){
                  entwurfsData.design = globalsObject.controller.model.entwurf.getDesign();
                }

                model.entwurf.setRdyDesignID(rdyDesignID);
                ReadyDesignLoader.setEntwurfsColorsToReadyDesignColors(model.entwurf, entwurfsData.colors)
                ReadyDesignLoader.initReadyDesignPatterns(entwurfsData.patterns);
                globalsObject.controller.changeDesign(entwurfsData.design);
                model.entwurf.loadLogoObjects(entwurfsData.logos || []);
                model.entwurf.loadTextObjects(entwurfsData.textobjects || []);

                ReadyDesignLoader.broadcastSelObInsertion(
                    model.entwurf.getZOrderTable(),
                    (model.entwurf.getTextObjects() as TextObject[] as SelectableObject[])
                        .concat(model.entwurf.getLogoObjects() as SelectableObject[])
                );
                resolve();
            });
        })
    }

    private static broadcastSelObInsertion(zOrderTable:Z_OrderTable, a:SelectableObject[]) {
        // const selObIds = a.map(s=>s.id);
        // const task = resourceManager.createTask("recreateShadersAfterReadyDesignLoad").discardAfterExecution();
        // selObIds.forEach(id=>task.when(id+"_initialized", "loaded"));
        // task.thenDo(()=>setTimeout(()=>EventVerteiler.broadcast("recreateAllShadersEvent"), 1000));
        a.forEach(s=>EventVerteiler.broadcast(SELOBEVENTNAMES.INSERTED, {
            selOb: s,
            zIndex: zOrderTable.getZIndex(s.id)
        }));

    }

    private static waitForEntwurfInitialisation():Promise<void> {
        return new Promise<void>((resolve)=>{
            globalsObject.resourceManager.createTask("readyDesignInitialisation")
                .discardAfterExecution()
                .when("designtexturesLoaded", "done")
                .andWhen("fonts", "loaded")
                //.andWhen("stocklogosloaded", "done")
                .andWhen("owayoJSViewerWithSelObs_parts.json_Loaded", "loaded")
                .thenDo(()=> resolve());
        })
    }

    private static initReadyDesignPatterns(patterns){
        globalsObject.resourceManager.createTask("initReadyDesignPatterns")
            .discardAfterExecution()
            .thenDo(()=> {
                globalsObject.controller.model.entwurf.deleteAllPatterns()
                EntwurfInitialisator.initReadyDesignPatterns(patterns)
            });
    }

    private static setEntwurfsColorsToReadyDesignColors(entwurf:IEntwurfStoreWrapper, colors:EntwurfColorData[]){
        entwurf.getColorObjects().forEach(
            colorObject => {
                const readyDesignColorObject = arrayElementByKeyValue(colors, "bezeichnung", colorObject.colorCode);
                if(readyDesignColorObject === null) {
                    return;
                }
                colorObject.colorValue = parseInt(readyDesignColorObject.colorRGB);
            }
        );
        globalsObject.resourceManager.executeInvalidation("colorValueWasSet");
        EventVerteiler.broadcast("initColorsEvent", {colorCodes: entwurf.getColorObjects()});
    }

    private static loadDesignDataAndWaitForCompletion(resourceName, url, data):Promise<EntwurfFromDB> {

        globalsObject.resourceManager.registerResource(
            {resourceName: resourceName, failHandler: ()=>ReadyDesignLoader.errorHandler("readyDesign load")}
        ).invalidAfter("loadnewrdydesign").load({method: "POST",url,data});

        return new Promise<EntwurfFromDB>((resolve)=>{
            globalsObject.resourceManager.createTask("adaptReadyDesign")
                .invalidAfter(ResourceInvalidationTriggers.PRODUCTCHANGE).invalidAfter("loadnewrdydesign")
                .when(resourceName, "loaded")
                .when("produkt.php", "loaded")
                .thenDo((data:Produktresponse)=>resolve(data[resourceName]));
        });
    }

    private static errorHandler = (happenedInThisStep:string)=>globalsObject.errorHandler.handleError(
        "ajaxFail",
        happenedInThisStep,
        "could not load ready design, sorry"
    );

    public static loadReadyDesign(model:IOwayoDataModel, ordertype, readydesign){
        return new Promise<void>((resolve)=>{
            ReadyDesignLoader.loadDesignDataAndWaitForCompletion(
                "loadReadyDesign.php",
                "/konfigurator_php/auswahlmodul/loadReadyDesign.php",
                {ordertype, readydesign}
            ).then(data=>ReadyDesignLoader.adaptReadyDesign(model, data, readydesign).then(resolve));
        });
    }

    public static logReadyDesign(readydesigncode, typ, sport, product){
        const domain = getURLPrefixOfflineVsOnline();
        const url = domain+"/newhp/php/logRDY.php";
        const data = {type:typ, readydesigncode:readydesigncode, land:globalsObject.infoFromGetParameters.land, language:globalsObject.infoFromGetParameters.lang, sport:sport, produkt:product};

        if (this.loggedReadys.has(readydesigncode) && (typ == " ImpressionsKonfi")) {
            return;
        }

        this.loggedReadys.add(readydesigncode);
        return new Promise<void>(resolve => {sendPostRequest(url,data).then(() => resolve()) });
    }

    public static loadFacebookPost(model:IOwayoDataModel, zufallsID) {
        return new Promise<void>((resolve) => {
            ReadyDesignLoader.loadDesignDataAndWaitForCompletion(
                "loadFacebookPost.php",
                "/konfigurator_php/auswahlmodul/loadFacebookPost.php",
                {zufallsID}
            ).then(data => ReadyDesignLoader.adaptReadyDesign(model, data, '').then(resolve));
        });
    }
}
